import { useState } from "react";
import { Link } from "react-router-dom";
import croonusLogo from "../../assets/images/logo/croonus-logo-powered.png";
import useAPI from "../../hooks/useAPI";
import CreateForm from "components/Form/CreateForm/CreateForm";
import Sitemap from "routes/sitemap";
import Loading from "components/Loading/Loading";
import scss from "./RegistrationPage.module.scss";
import loginScss from "../Login/LoginPage.module.scss";
import { splitSubtitle } from "../../helpers/authPresentation";
// import formFields from "./formFields.json";
import { useTranslation } from "react-i18next";
import { printError } from "../../helpers/apiError";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
/**
 * The login page for the B2B.
 *
 * @return {JSX.Element}
 * @constructor
 */

function generateEmptyObject(array) {
    return array.reduce((acc, item) => {
        acc[item.key] = null;
        return acc;
    }, {});
}

const RegistrationPage = () => {
    const { t } = useTranslation();

    const api = useAPI();

    const { data: subtitle = "" } = useQuery(["authPresentationSubtitle"], () => api.get("/configuration/presentation/login/subtitle/value", false));
    const subtitleLines = splitSubtitle(subtitle);

    const [data, setData] = useState({});
    const [message, setMessage] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isSent, setIsSent] = useState(false);

    const [fieldsError, setFieldsError] = useState(null);

    const { data: registrationFields, isLoading: fieldsLoading, isError: fieldsFailed, refetch } = useQuery(["registrationFields"], () => api.get(`/customer/registration-fields`));

    const submitHandler = () => {
        if (isLoading || !registrationFields) return;
        setFieldsError(null);
        setIsLoading(true);
        const init = generateEmptyObject(registrationFields);

        api.post("customer/registration", { ...init, ...data })
            .then((response) => {
                setMessage(response?.message ? response.message : t("registration-default-form-message-success_registration"));
                setIsLoading(false);
                setIsSent(true);
            })
            .catch((error) => {
                setIsLoading(false);

                setFieldsError(error?.response?.data?.payload?.fields);
                if (error?.response?.data?.payload?.fields) return;

                toast.error(printError(error) ? printError(error) : t("global-message-unknown_error"));
            });
    };

    let formFields;
    if (registrationFields) {
        formFields = registrationFields.map((field) => {
            const note = field.key.startsWith("note");
            const typeString = field.fields_rule.includes("string");

            return {
                columns: note ? 12 : true,
                disabled: false,
                field: field.key,
                label: `registration-default-form-field-${field.key}-label`,
                placeholder: "",
                required: field.fields_rule.includes("required"),
                rows: note ? 3 : false,
                type: note ? "textarea" : typeString ? "text" : "number",
            };
        });
    }

    return (
        <main className={loginScss["login-container"]}>
            <div className={`${loginScss["login-card"]} ${loginScss.compactCard}`}>
                <div className={loginScss["background-wrapper"]}>
                    <img src={api.buildPath("/configuration/images/presentation/login/image")} alt="" />
                    <div />
                </div>
                <div className={`${loginScss["login-card-gray-overlay"]} ${scss.layout}`}>
                    <div className={`${loginScss.logoHolder} ${scss.brand}`}>
                        <img src={api.buildPath("/configuration/images/presentation/login/logo")} className={loginScss.logo} alt="Logo kompanije" />
                        <p className={loginScss.logoText} title={subtitle}>
                            <span className={loginScss.srOnly}>{subtitle}</span>
                            {subtitleLines.map((line, index) => <span key={index} aria-hidden="true">{line}</span>)}
                        </p>
                    </div>
                    <div className={scss.intro}>
                        <span className={scss.eyebrow}>ZA POSLOVNE PARTNERE</span>
                        <h1 className={scss.title}>{t("registration-default-text-become_user")}</h1>
                        <p className={scss.description}>{t("registration-default-text-info")}</p>
                    </div>
                    <div className={scss.content}>
                        <header className={scss.formHeading}>
                            <span className={scss.formIcon} aria-hidden="true">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="7" width="18" height="14" rx="2" /><path d="M8 7V4h8v3M3 12a22 22 0 0 0 18 0M12 11v4" /></svg>
                            </span>
                            <div><span className={scss.formEyebrow}>B2B ZAHTEV</span><h2>Vaši poslovni podaci</h2></div>
                        </header>
                        {message && <div className={scss.message} role="status">{message}</div>}
                        {fieldsLoading && <Loading size={28} />}
                        {fieldsFailed && <div className={scss.loadError} role="alert"><p>Podatke za zahtev trenutno nije moguće učitati.</p><button type="button" onClick={() => refetch()}>Pokušaj ponovo</button></div>}
                        {!isSent && formFields && (
                            <CreateForm
                                fieldsError={fieldsError}
                                data={data}
                                setData={setData}
                                formFields={formFields}
                                className={scss.form}
                                submit={{ label: "registration-default-form-button-submit", action: submitHandler }}
                                formButtons={true}
                                loading={isLoading}
                            />
                        )}
                        <div className={`${loginScss.register} ${scss.signIn}`}>
                            <span>{t("registration-default-text-already_have_account")}</span>
                            <Link to={Sitemap.auth.login}>{t("login-default-form-button-submit", "Prijavite se")}</Link>
                        </div>
                    </div>
                    <div className={`${loginScss.powered} ${scss.powered}`}>
                        <p className={loginScss.paragraph}>{t("login-default-text-powered_by")}: </p>
                        <a href="https://croonus.com/" target="_blank" rel="noopener noreferrer"><img src={croonusLogo} alt="Croonus logo" /></a>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default RegistrationPage;
